import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import '../Work.css';
import { useNavigate } from "react-router-dom";
import posterv1 from "../../assets/Images/posterv1.png";
import posterv1process1 from "../../assets/Images/posterv1process1.png";
import posterv1process2 from "../../assets/Images/posterv1process2.png";
import videolab1 from "../../assets/Videos/videolab1.mp4";







const WorkVideolab = () => {
    const navigate = useNavigate();

    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-work-headings">
                <h1>Observation</h1>
                <p>My group thought about checking our Client's perspective</p>

                
            </div>

            <div className="line"></div>

            <div className="content-work">
                <div className="content-work-videolab">

                    <div className="content-work-videolab-text">
                        <h1>Pixel Playground Visit</h1>
                        <p></p>

                        <p>We gather more information during this visit, the reason why we go to the Pixel 
                            Playground is because we want to ask our stakeholder their opinion, we also want
                            to know what can we do in the pixel playground, one of the thing that I found
                            interesting is that with the pixel playground we could use our creativity to create
                            an interesting movie related products, because in pixel playground we use unreal engine
                            to make our background realistic, there are lot of possibilities that is available with
                            virtual Production  
                        </p>

                        <p>
                            I understand more about Virtual Production after this visit. Also the video on the 
                            right is just one of the activities that we can do on Pixel Playground.
                        </p>


                        

                    </div>

                    <div className="content-work-videolab-image">
                        <video width="100%" controls>
                            <source src={videolab1} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>

                    


                </div>
            </div>

            <Footer />
            </div>
    );
};

export default WorkVideolab;